module.exports = __webpack_public_path__ + "static/media/logo.039e8c8b.jpeg";